import { PaymentPlanKey } from 'api/clients/PaymentPlanClient'
import { useRootStore } from 'stores/RootStore'
import { useBrandProfile } from 'hooks/queries/workspaces/useBrandProfile'
import { useFlipperFlag } from './useFlipperFlag'

export const useNeedsCreditsToGenerateContent = () => {
  const isPioneerCreditsEnabled = useFlipperFlag('pioneer_credits')
  const profile = useBrandProfile({ cacheTime: 5 * 60 * 1000 })
  const hasAnimatedImage = !!profile?.data?.brand_kit?.content_preferences?.video_sources?.includes('animated_image')
  const hasStylizedImage = !!profile?.data?.brand_kit?.content_preferences?.apply_visual_style
  const {
    creditUsageStore: { creditUsage },
    tierUsageStore: { currentSubscription, autopilotAddOns },
  } = useRootStore()
  const autopilotContentCreditsAddon = autopilotAddOns.find(
    (addon) => addon.key === PaymentPlanKey.BlazeAutopilotContentCredits,
  )
  const autopilotContentCreditsPrice = autopilotContentCreditsAddon?.prices[0]
  const isOnPioneer = currentSubscription?.plan === PaymentPlanKey.VirtualMarketer
  const isTrialing = currentSubscription?.status === 'trialing'

  let needsCredits = !!creditUsage && Object.keys(creditUsage).length > 0 && creditUsage.credits_remaining === 0

  if (isOnPioneer) {
    needsCredits = isPioneerCreditsEnabled && needsCredits && !isTrialing && (hasAnimatedImage || hasStylizedImage)
  }

  return {
    needsCredits,
    autopilotContentCreditsPrice,
  }
}
